[
{
  "link": "/fever",
  "name": "Fever"
},
{
  "link": "/chickenpox",
  "name": "Chickenpox"
},
{
  "link": "/pneumonia",
  "name": "Pneumonia"
},
{
  "link": "/high-blood-pressure",
  "name": "High Blood Pressure"
},
{
  "link": "/diabetes",
  "name": "Diabetes"
},
{
  "link": "/cold",
  "name": "Cold"
},
{
  "link": "/childs-cold",
  "name": "Child's cold"
},
{
  "link": "/childs-cough",
  "name": "Child's cough"
},
{
  "link": "/nausea",
  "name": "Nausea"
},
{
  "link": "/pertussis",
  "name": "Pertussis"
},
{
  "link": "/diarrhea",
  "name": "Diarrhea"
},
{
  "link": "/heartburn",
  "name": "Heartburn"
},
{
  "link": "/pain",
  "name": "Pain"
},
{
  "link": "/back-pain",
  "name": "Back Pain"
},
{
  "link": "/headache",
  "name": "Headache"
},
{
  "link": "/abdominal-pain",
  "name": "Abdominal pain"
},
{
  "link": "/sore-throat",
  "name": "Sore throat"
},
{
  "link": "/dermatitis",
  "name": "Dermatitis"
},
{
  "link": "/vaccination",
  "name": "Vaccination"
},
{
  "link": "/anemia",
  "name": "Anemia"
},
{
  "link": "/dizziness",
  "name": "Dizziness"
},
{
  "link": "/urinary-problems",
  "name": "Urinary problems"
},
{
  "link": "/flu",
  "name": "Flu"
},
{
  "link": "/allergy",
  "name": "Allergy"
},
{
  "link": "/conjunctivitis",
  "name": "Conjunctivitis"
}]